module.exports = __webpack_public_path__ + "img/icon_tuandui.14b3d507.png";